import { z } from 'zod';
import { getQSTActionDetailSchema } from './getQSTActionDetails';
export const getQSTActionSchema = z.array(
  z.object({
    id: z.string(),
    isFromManager: z.boolean(),
    isActive: z.boolean(),
    description: z.string(),
    updateUserID: z.string().optional(),
    qstActionDetails: getQSTActionDetailSchema,
  })
);
export type GetDeliveryTypesResponse = z.infer<typeof getQSTActionSchema>;
